export default [
	{
		display: 'Argentina',
		iso2: 'AR',
		format: '999 9999-9999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Australia',
		iso2: 'AU',
		format: '(99) 9999 9999',
		mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Austria',
		iso2: 'AT',
		format: '9999 999999',
		mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Belgium',
		iso2: 'BE',
		format: '99 999 99 99',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Brazil',
		iso2: 'BR',
		format: '(99) 9999-9999',
		mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Bulgaria',
		iso2: 'BG',
		format: '99 999 9999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Canada',
		iso2: 'CA',
		format: '(999) 999-9999',
		mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Colombia',
		iso2: 'CO',
		format: '(9) 9999999',
		mask: ['(', /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Croatia',
		iso2: 'HR',
		format: '99 9999 999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
	},
	{
		display: 'Cyprus',
		iso2: 'CY',
		format: '99 999999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Czech Republic',
		iso2: 'CZ',
		format: '999 999 999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
	},
	{
		display: 'Denmark',
		iso2: 'DK',
		format: '99 99 99 99',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Dominican Republic',
		iso2: 'DO',
		format: '(999) 999-9999',
		mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'El Salvador',
		iso2: 'SV',
		format: '9999 9999',
		mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Estonia',
		iso2: 'EE',
		format: '999 9999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Finland',
		iso2: 'FI',
		format: '99 99999999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'France',
		iso2: 'FR',
		format: '99 99 99 99 99',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Germany',
		iso2: 'DE',
		format: '999 99999999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Greece',
		iso2: 'GR',
		format: '99 9999 9999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Hong Kong',
		iso2: 'HK',
		format: '9999 9999',
		mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Hungary',
		iso2: 'HU',
		format: '(9) 999 9999',
		mask: ['(', /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Ireland',
		iso2: 'IE',
		format: '(99) 999 9999',
		mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Israel',
		iso2: 'IL',
		format: '999-999-9999',
		mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Italy',
		iso2: 'IT',
		format: '99 9999 9999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Japan',
		iso2: 'JP',
		format: '99-9999-9999',
		mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Latvia',
		iso2: 'LV',
		format: '99 999 999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
	},
	{
		display: 'Lithuania',
		iso2: 'LT',
		format: '(9-9) 999 9999',
		mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Luxembourg',
		iso2: 'LU',
		format: '99 99 99 99',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Malaysia',
		iso2: 'MY',
		format: '99-9999 9999',
		mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Malta',
		iso2: 'MT',
		format: '9999 9999',
		mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Mexico',
		iso2: 'MX',
		format: '99 99 9999 9999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Netherlands',
		iso2: 'NL',
		format: '999 999 9999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'New Zealand',
		iso2: 'NZ',
		format: '99-999 9999',
		mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Norway',
		iso2: 'NO',
		format: '99 99 99 99',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Panama',
		iso2: 'PA',
		format: '999-9999',
		mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Peru',
		iso2: 'PE',
		format: '(99) 9999999',
		mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Poland',
		iso2: 'PL',
		format: '99 999 99 99',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Portugal',
		iso2: 'PT',
		format: '999 999 999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
	},
	{
		display: 'Puerto Rico',
		iso2: 'PR',
		format: '(999) 999-9999',
		mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Romania',
		iso2: 'RO',
		format: '999 999 9999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Singapore',
		iso2: 'SG',
		format: '9999 9999',
		mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Slovakia',
		iso2: 'SK',
		format: '99/999 999 99',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Slovenia',
		iso2: 'SI',
		format: '(99) 999 99 99',
		mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'South Africa',
		iso2: 'ZA',
		format: '999 999 9999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'South Korea',
		iso2: 'KR',
		format: '99-9999-9999',
		mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'Spain',
		iso2: 'ES',
		format: '999 99 99 99',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Sweden',
		iso2: 'SE',
		format: '99-999 999 99',
		mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Switzerland',
		iso2: 'CH',
		format: '999 999 99 99',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
	},
	{
		display: 'Taiwan, Province of China',
		iso2: 'TW',
		format: '99 9999 9999',
		mask: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'United Kingdom',
		iso2: 'GB',
		format: '999 9999 9999',
		mask: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'United States',
		iso2: 'US',
		format: '(999) 999-999',
		mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
	},
	{
		display: 'International',
		iso2: 'INT',
		format: '+ 9 9999999999',
		mask: ['+', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
	},
];
